"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'nav.avatar.fallback': '头像',
    'nav.avatar.alt': '头像',
    'nav.avatar.loading': '正在加载头像...',
};
